import { ConfigProvider } from 'antd';
import { FunctionComponent } from 'react';
import { defaultThemeConfig } from '../../styles/theme';
import { ErrorBoundary } from './ErrorBoundary';

export default function withErrorBoundary(WrappedComponent: FunctionComponent): FunctionComponent {
    return function (props = {}) {
        return (
            <ConfigProvider theme={defaultThemeConfig}>
                <ErrorBoundary
                    onError={(_error, _errorInfo) => {
                        // TODO: performance, removed for performance optimization, uncomment later
                        // // https://docs.sentry.io/platforms/javascript/guides/nextjs/usage/#capturing-errors
                        // reportError(error, errorInfo);
                    }}
                >
                    <WrappedComponent {...props} />
                </ErrorBoundary>
            </ConfigProvider>
        );
    };
}
